import { Button } from "primereact/button";
import { useMutation } from "react-relay";
import { type deleteExternalLicenseButton_DeleteExternalLicenseMutation } from "@relay/deleteExternalLicenseButton_DeleteExternalLicenseMutation.graphql";
import { DELETE_EXTERNAL_LICENSE_MUTATION } from "./delete-external-license-button.graphql";
import { type DeleteExternalLicenseButtonProps } from "./delete-external-license-button.interface";

export const DeleteExternalLicenseButton = (props: DeleteExternalLicenseButtonProps) => {
	const [deleteExternalLicense] =
		useMutation<deleteExternalLicenseButton_DeleteExternalLicenseMutation>(
			DELETE_EXTERNAL_LICENSE_MUTATION,
		);

	const onClick = () =>
		deleteExternalLicense({
			variables: {
				input: {
					ids: [props.externalLicenseId],
				},
				connections: props.connections,
			},
		});

	return <Button onClick={onClick} icon="pi pi-trash" />;
};
